module.exports = __webpack_public_path__ + "img/residences_inventory.e63a846e.svg";